import { createStore, createHook } from 'react-sweet-state';

const Store = createStore({
	initialState: {
		isAutoConverted: false,
	},
	actions: {
		setIsAutoConverted:
			(isAutoConverted) =>
			({ setState }) => {
				setState({
					isAutoConverted,
				});
			},
	},
	name: 'isAutoConverted',
});

const getAutoConvertState = (state: { isAutoConverted: boolean }) => {
	return state.isAutoConverted;
};

export const useAutoConvertState = createHook(Store, {
	selector: getAutoConvertState,
});
